export const ariaBooleanToString = (value) => {
    if (value === undefined || value === null) {
        return undefined;
    }
    return !!value ? 'true' : 'false';
};
